import React, { createContext, useContext, useEffect, useState } from "react";
import config from "../config";
import { detectBrowserLanguage } from "../helper/languageHelper";

const StaticContext = createContext();

export const StaticProvider = ({ children }) => {
  const [buttonURLs, setButtonURLs] = useState([]);
  const [updateMode, setUpdateMode] = useState(false);
  const [activeTabs, setActiveTabs] = useState(["tumu"]);
  const [activeMainCategory, setActiveMainCategory] = useState("bonuslar");
  const [captchaKey, setCaptchaKey] = useState("");
  const [selectedBonus, setSelectedBonus] = useState(null);
  const [title, setTitle] = useState("HookOtoBonus");
  const [isLanguage, setIsLanguage] = useState(false);
  const [selectedLanguage, setSelectedLanguage] = useState(detectBrowserLanguage());

  useEffect(() => {
    const fetchStatic = async () => {
      try {
        // window.rh kontrolü
        if (!window.rh || !window.rh.cr) {
          console.error("hk.js yüklenemedi, window.rh bulunamadı");
          return;
        }

        let body = JSON.stringify({
          process_id: "get-static",
          user_id: "1",
        });
        let keys = await window.rh.cr(body);

        const response = await fetch(`${config.apiBaseUrl}`, {
          method: "POST",
          headers: { "Content-Type": "application/json",
            "hk": keys[0],
            "hh": keys[1] 
           },
          body: body,
        });
        const data = await response.json();
        setTitle(data.title);
        setCaptchaKey(data.captcha_key);
        setUpdateMode(data.bakim);
        setButtonURLs(data);
        
        // isLanguage alanını kontrol et
        if (data.isLanguage !== undefined) {
          setIsLanguage(data.isLanguage);
        }
      } catch (error) {
        console.error("Error fetching styles:", error);
      }
    };

    fetchStatic();
  }, []);

  return (
    <StaticContext.Provider
      value={{
        captchaKey,
        buttonURLs,
        updateMode,
        title,
        activeTabs,
        setActiveTabs,
        activeMainCategory,
        setActiveMainCategory,
        selectedBonus,
        setSelectedBonus,
        isLanguage,
        selectedLanguage,
        setSelectedLanguage,
      }}
    >
      {children}
    </StaticContext.Provider>
  );
};

export const useStatic = () => useContext(StaticContext);
